import React from 'react';

const PythagoreanTheoremCalculator = () => {
  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Pythagorean Theorem Calculator</h2>
      <div className="bg-white p-6 rounded-lg shadow-md">
        <p>Calculate the length of the hypotenuse or a leg of a right triangle using the Pythagorean theorem (a² + b² = c²).</p>
      </div>
    </div>
  );
};

export default PythagoreanTheoremCalculator;